import styled from 'styled-components';

import Tables from 'styles/tables';

export const CategoryItemsHeader = styled(Tables.ItemsHeader)`
  grid-template-columns: 6rem 15rem 16rem 7rem;
  padding: 1.25rem 1rem;

  @media screen and (min-width: 1240px) {
    grid-template-columns: 6rem 1fr 16rem 7rem;
  }
`;

export const CategoryItemsBody = styled(Tables.ItemsBody)`
  grid-template-columns: 6rem 15rem 16rem 7rem;
  padding: 1rem;

  @media screen and (min-width: 1240px) {
    grid-template-columns: 6rem 1fr 16rem 7rem;
  }
`;
